import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'

// OBTENER PERSONAL
export const getPersonall = async () => {
    const response = await PrivateInterceptor('Payrolls/Personal', 'GET');
    return response;
}

// OBTENER PERSONAL - SUPERIOR
export const getPersonalAct = async () => {
    const response = await PrivateInterceptor('Payrolls/Personal/PersonalAct', 'GET');
    return response;
}

// GUARDAR PERSONAL
export const GuardarPersonal = (Datos) => {
    const respuesta = PrivateInterceptor("Payrolls/Personal/AgregarPersonal", "POST", {Datos});
    return respuesta;
};

// GUARDAR PERSONAL
export const EditarPersonal = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Personal/EditarPersonal", "POST", {Datos});
  return respuesta;
};

// OBTENER SEXOS
export const getSexos = async () => {
    const response = await PrivateInterceptor('Payrolls/Personal/Sexos', 'GET');
    return response;
}

// OBTENER ESTADOS CIVIL
export const getEstadosCivil = async () => {
    const response = await PrivateInterceptor('Payrolls/Personal/EstadoCivil', 'GET');
    return response;
}

export const chageEstadoPersonal = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Personal/chageEstadoPersonal`, 'POST', data);
  return result;
}